import type {Answer, SavedRun, Snapshot} from './types.ts';
export const emptyRun = ():SavedRun => ({answers:[],opened:{},finish:null,briefed:false});
export function reconcile(local:SavedRun, snapshot:Snapshot):SavedRun {
  const actions = new Map(local.answers.map(a=>[a.action_id,a]));
  for(const a of snapshot.accepted_actions) actions.set(a.action_id,a);
  const answers = [...actions.values()].sort((a,b)=>a.sequence-b.sequence);
  const opened = {...local.opened};
  for(const a of answers) opened[a.scenario_id]=a.opened_ms;
  const finish=local.finish??(snapshot.finish_sequence!==null?{sequence:snapshot.finish_sequence,elapsed_ms:snapshot.finish_elapsed_ms??snapshot.room.duration_ms}:null);
  return {...local,answers,opened,finish};
}
export function pendingAnswers(local:SavedRun,snapshot:Snapshot|null):Answer[] {
  const accepted = new Set(snapshot?.accepted_actions.map(a=>a.action_id)??[]);
  return local.answers.filter(a=>!accepted.has(a.action_id));
}
let database:Promise<IDBDatabase>|undefined;
function db() {
  return database??=new Promise<IDBDatabase>((resolve,reject)=>{
    const request=indexedDB.open('fraud-attacks-player',1);
    request.onupgradeneeded=()=>request.result.createObjectStore('attempts');
    request.onsuccess=()=>resolve(request.result);
    request.onerror=()=>reject(request.error);
    request.onblocked=()=>reject(new Error('Local storage is blocked.'));
  });
}
export async function readRun(id:string):Promise<SavedRun> {
  const database=await db();
  return new Promise((resolve,reject)=>{
    const request=database.transaction('attempts').objectStore('attempts').get(id);
    request.onsuccess=()=>resolve(request.result??emptyRun());
    request.onerror=()=>reject(request.error);
  });
}
export async function saveRun(id:string,run:SavedRun):Promise<void> {
  const database=await db();
  return new Promise((resolve,reject)=>{
    const transaction=database.transaction('attempts','readwrite');
    transaction.objectStore('attempts').put(structuredClone(run),id);
    transaction.oncomplete=()=>resolve();
    transaction.onerror=()=>reject(transaction.error);
    transaction.onabort=()=>reject(transaction.error);
  });
}
